import { DropdownButton, Tooltip } from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';

import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';

import { ConversationHeaderPastAssignees } from './components/pastAssignees/conversationHeaderPastAssignees';
import styles from './conversationHeaderMoreMenu.module.scss';

export const ConversationHeaderMoreMenu = (): JSX.Element | null => {
  const flags = useFeatureFlag(['conversation-focus-mode']);

  return flags.conversationFocusMode ? null : (
    <Tooltip dark content="View more actions">
      <DropdownButton
        icon="dots-v"
        buttonProps={{ variant: 'tertiary' }}
        onToggle={(isOpen) =>
          isOpen && ampli.conversationHeaderMoreMenuOpened()
        }
        dropdown={
          <div className={styles.dropdownContent}>
            <ConversationHeaderPastAssignees />
          </div>
        }
      />
    </Tooltip>
  );
};
